<template>
    <div class="stripe-container">

    </div>
</template>

<script>
    module.exports = {
        created:function() {

        },
        data:function() {
            return {

            }
        },
        props: {

        },
        methods: {

        },
        mounted:function() {

        }
    }
</script>
